import * as types from "./customerInformationActionTypes";

export default (state = null, action) => {
    switch (action.type) {
        case types.LOAD_CUSTOMER_INFORMATION_FAILED:
            return action.message;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/customer-information/customerInformationErrorReducer.js